'use strict';
/**
 * BD.AgeVerification: Show Age Verification popup
 */

var BD = window.BD = window.BD || {};

BD.AgeVerification = function ($) {
  var verificationCookie = "bd-ageVerification";

  function handleYesClicked() {
    var verified = Cookies.get(verificationCookie);
    Cookies.set(verificationCookie, 'true', {
      expires: 60
    });
  }

  function handleNoClicked() {
    /* No action - "no" is just a close button */
  }

  function init() {
    var $popup = $('#age-verification-modal');

    if (!$popup.length) {
      return;
    }

    var verified = Cookies.get(verificationCookie);

    if (verified !== 'true') {
      NA.Modal.triggerModal($popup);
      $popup.on('click', '.btn-yes', handleYesClicked);
      $popup.on('click', '.btn-no', handleNoClicked);
    }
  }

  $(init);
}(jQuery);
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * BD.BlackoutDates: Tools for calculating and formatting blackout dates
 */
window.BD = window.BD || {};

window.BD.BlackoutDates = /*#__PURE__*/function () {
  function _class(blackoutDateStr) {
    _classCallCheck(this, _class);

    this.blackoutDates = this.buildBlackoutDates(blackoutDateStr);
    this.fnFilterBlackouts = this.filterBlackouts.bind(this);
    this.dateRangeJoin = '-';
  }

  _createClass(_class, [{
    key: "buildBlackoutDates",
    value: function buildBlackoutDates(str) {
      if (!str) {
        return [];
      }

      var lines = str.split('\n');
      return lines.map(function (line) {
        if (!line || !line.length) {
          return null;
        }

        if (line.startsWith('#')) {
          return null;
        }

        if (line.length === 3) {
          var dayOfWeek = window.BD.BlackoutDates.WEEKDAYS.indexOf(line.toUpperCase());

          if (dayOfWeek === -1) {
            console.error("Unrecognized day: ".concat(line));
            return null;
          }

          return {
            type: window.BD.BlackoutDates.RULE_WEEKDAY,
            dayOfWeek: dayOfWeek,
            filter: window.BD.BlackoutDates.weekdayFilter
          };
        }

        var dateRangeMatches = line.match(/(\d{4})-(\d{2})-(\d{2})\s*-\s*(\d{4})-(\d{2})-(\d{2})/);

        if (dateRangeMatches) {
          var fromDate = new Date("".concat(dateRangeMatches[1], "-").concat(dateRangeMatches[2], "-").concat(dateRangeMatches[3]));
          var toDate = new Date("".concat(dateRangeMatches[4], "-").concat(dateRangeMatches[5], "-").concat(dateRangeMatches[6]));
          return {
            type: window.BD.BlackoutDates.RULE_DATE_RANGE,
            fromYear: dateRangeMatches[1],
            fromMonth: dateRangeMatches[2],
            fromDay: dateRangeMatches[3],
            toYear: dateRangeMatches[4],
            toMonth: dateRangeMatches[5],
            toDay: dateRangeMatches[6],
            fromDate: fromDate,
            toDate: toDate,
            fromTstamp: fromDate.getTime(),
            toTstamp: toDate.getTime(),
            filter: window.BD.BlackoutDates.dateRangeFilter
          };
        }

        var dateMatches = line.match(/(\d{4})-(\d{2})-(\d{2})/);

        if (dateMatches) {
          var date = new Date("".concat(dateMatches[1], "-").concat(dateMatches[2], "-").concat(dateMatches[3]));
          return {
            type: window.BD.BlackoutDates.RULE_DATE,
            year: dateMatches[1],
            month: dateMatches[2],
            day: dateMatches[3],
            date: date,
            tstamp: date.getTime(),
            filter: window.BD.BlackoutDates.dateFilter
          };
        }

        console.error("Unrecognized rule: ".concat(line));
        return null;
      }).filter(function (rule) {
        return !!rule;
      });
    }
  }, {
    key: "filterBlackouts",
    value: function filterBlackouts(date) {
      // Note we negate the filter here.  This is because blackout date filters are intended
      // to only return valid dates, but we're trying to find dates that match any blackout, i.e.
      // the ones that are _not_ passed by the blackout filters.
      var matchingBlackoutDate = this.blackoutDates.find(function (blackoutDate) {
        return !blackoutDate.filter(date);
      });
      return !matchingBlackoutDate;
    }
  }, {
    key: "buildDateStr",
    value: function buildDateStr(dates) {
      var _this = this;

      var joinStr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '<br />';
      var validDates = dates.filter(this.fnFilterBlackouts);

      if (!validDates) {
        return '';
      }

      validDates.sort(function (a, b) {
        return a.getTime() - b.getTime();
      });
      var validMoments = validDates.map(function (date) {
        return window.moment(date);
      });

      var fnRenderDateRange = function fnRenderDateRange(d1, d2) {
        var formattedStart = d1.utc().format(window.BD.BlackoutDates.TOUR_FORMAT);
        var formattedEnd = d2.utc().format(window.BD.BlackoutDates.TOUR_FORMAT);

        if (formattedStart != formattedEnd) {
          return "".concat(formattedStart, " ").concat(_this.dateRangeJoin, " ").concat(formattedEnd);
        } else {
          return formattedStart;
        }
      };

      var stringBuilder = validMoments.reduce(function (acc, date, idx, validMoments) {
        var isLast = idx === validMoments.length - 1;
        var yesterday = date.clone().subtract(1, 'day');
        var isRangeStart = !yesterday.isSame(acc.prevDate); // If we're starting a new range but have an old range in memory, spit out the previous range

        var prevRangeEnded = isRangeStart && acc.rangeEnd;
        acc.prevDate = date;

        if (prevRangeEnded) {
          acc.strings.push(fnRenderDateRange(acc.rangeStart, acc.rangeEnd));
          acc.rangeStart = null;
          acc.rangeEnd = null;
        } else if (!isLast) {
          acc.rangeEnd = date;

          if (!acc.rangeStart) {
            acc.rangeStart = date;
          }

          return acc;
        }

        acc.strings.push(fnRenderDateRange(acc.rangeStart || date, date));
        return acc;
      }, {
        strings: [],
        lastDate: null,
        rangeStart: null,
        rangeEnd: null
      });
      return stringBuilder.strings.join(joinStr);
    }
  }]);

  return _class;
}();

window.BD.BlackoutDates.WEEKDAYS = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
window.BD.BlackoutDates.RULE_WEEKDAY = 'weekday';
window.BD.BlackoutDates.RULE_DATE = 'date';
window.BD.BlackoutDates.RULE_DATE_RANGE = 'daterange';
window.BD.BlackoutDates.TOUR_FORMAT = 'ddd MMMM D YYYY';

window.BD.BlackoutDates.dateRangeFilter = function (date) {
  var tstamp = date.getTime();
  return tstamp < this.fromTstamp || tstamp > this.toTstamp;
};

window.BD.BlackoutDates.dateFilter = function (date) {
  var tstamp = date.getTime();
  return tstamp != this.tstamp;
};

window.BD.BlackoutDates.weekdayFilter = function (date) {
  var day = date.getUTCDay();
  return day != this.dayOfWeek;
};
'use strict';
/**
 * BD.Checkout: Handle checkout scripting
 */

var BD = window.BD = window.BD || {};

BD.Checkout = function ($) {
  var $ageCheckbox;
  var $orderForm;
  var $submitButtons;

  function updateCheckoutAvailability() {
    $submitButtons.toggleClass('disabled-but-clickable', !$ageCheckbox.is(':checked'));
    $submitButtons.toggleClass('disabled', !$ageCheckbox.is(':checked'));
  }

  function submitHandler(e) {
    if (!$ageCheckbox.is(':checked')) {
      $ageCheckbox.closest('.cartSummary__ageCheck').addClass('required');
      e.preventDefault();
      return false;
    }

    $orderForm.submit();
    return true;
  }

  function init() {
    $ageCheckbox = $('#chk_ageCheck');

    if (!$ageCheckbox.length) {
      return;
    }

    $orderForm = $('#frm_orderSummary');
    $submitButtons = $orderForm.find('button[type=submit]');
    $ageCheckbox.on('change', updateCheckoutAvailability);
    $orderForm.on('submit', submitHandler);
    $submitButtons.on('click', submitHandler);
    updateCheckoutAvailability();
  }

  function cartHasTour() {
    var tourLines = CartJS.cart.items.filter(function (line) {
      return line.product_type.toLowerCase() == 'tour' || line.product_type.toLowerCase() == 'private tour' || line.handle == 'private-tour-deposit';
    });
    return tourLines.length != 0;
  }
  /**
   * @return boolean True if this product type is only valid on carts containing a tour.
   */


  function productTypeRequiresTour(productType) {
    productType = productType.toLowerCase();
    return productType == 'custom-pickup';
  }

  function removeTourRelatedLineItemsAndRedirect() {
    var variantRemovals = {};
    var removalLines = CartJS.cart.items.filter(function (line) {
      return productTypeRequiresTour(line.product_type);
    });

    if (!removalLines.length) {
      return false;
    }

    removalLines.forEach(function (line) {
      variantRemovals[line.variant_id] = 0;
    });
    $.post('/cart/update.js', {
      updates: variantRemovals
    }, function () {
      console.log("Removed tour-related items from cart with no tour.");
      window.location.reload(true);
    });
    return true;
  }

  function validateCartOrRedirect() {
    if (!cartHasTour()) {
      removeTourRelatedLineItemsAndRedirect();
    }
  }

  $(init);
  return {
    validateCartOrRedirect: validateCartOrRedirect
  };
}(jQuery);
'use strict';
/**
 * BD.CollectionLoader: Loads all elements of a collection and calls a callback
 */

var BD = window.BD = window.BD || {};

BD.CollectionLoader = function ($) {
  function load(collectionHandle, callback) {
    this.callback = callback;
    this.collectionHandle = collectionHandle;
    this.loading = false;
    this.pagesComplete = false;
    this.lastRetrievedPage = 0;
    this.$allProducts = $('<div style="display: none"></div>').appendTo('body');
    this.loadNextPage = loadNextPage;
    this.loadNextPage();
    this.complete = complete;
    return this;
  }
  /**
   * Retrieve the next (or first) page of the tours, cache the results, and
   * start loading the next page.
   */


  function loadNextPage() {
    var _this = this;

    if (this.pagesComplete || this.loading) {
      return;
    }

    this.loading = true;
    this.lastRetrievedPage++;
    var url = '/collections/' + this.collectionHandle + '?view=raw&page=' + this.lastRetrievedPage;
    $.ajax(url, {
      success: function success(response) {
        if (!response.trim()) {
          _this.complete();
        }

        _this.$allProducts.append(response);

        var $hasMoreIndicator = _this.$allProducts.find('span.more-indicator');

        if ($hasMoreIndicator.length) {
          window.setTimeout(function () {
            return _this.loadNextPage();
          }, 1);
          $hasMoreIndicator.remove();
        } else {
          _this.complete();
        }
      },
      complete: function complete() {
        _this.loading = false;
      }
    });
  }

  function complete() {
    this.loading = false;
    this.callback && this.callback(this);
  }

  return {
    load: load
  };
}(jQuery);
'use strict';
/**
 * BD.CustomPickup: Manage the custom pickup box during checkout
 */

var BD = window.BD = window.BD || {};

BD.CustomPickup = function ($) {
  var customPickupHandles = ['custom-pickup', 'custom-pickup-10plus'];
  var attributeFields = ['Custom Pickup - Street', 'Custom Pickup - Apt', 'Custom Pickup - City', 'Custom Pickup - Postal Code', 'Custom Pickup - Phone', 'Custom Pickup - Special Instructions'];
  var attrLocationIsSet = 'Custom Pickup - Location Is Set';
  var $customPickup;
  var $showButton;
  var $removeButton;
  var $locationPanel;
  var $locationDescription;
  var $locationForm;
  var $noAddressCheckbox;
  var customPickupHandle;
  var customPickupVariant;
  var customPickupCity;

  function showLocationForm() {
    $locationForm.addClass('shown');
    attributeFields.forEach(function (attrName) {
      var val = $locationForm.find('[name="attributes[' + attrName + ']"]').val(CartJS.getAttribute(attrName));
    });
    $noAddressCheckbox.prop('checked', CartJS.getAttribute(attrLocationIsSet) == 'NO');
    $locationForm.find('[name="attributes[Custom Pickup - City]"]').val(customPickupCity);
    toggleNoAddressCheckbox();
    $showButton.prop('disabled', true);
  }
  /**
   * Convenience method to convert a "short key" like "Street" and get the associated cart attribute value.
   */


  function attrValueFromShortKey(shortKey) {
    return CartJS.getAttribute('Custom Pickup - ' + shortKey);
  }

  function getStreet() {
    return attrValueFromShortKey('Street');
  }

  function getApt() {
    return attrValueFromShortKey('Apt');
  }

  function getCity() {
    return attrValueFromShortKey('City');
  }

  function getPostal() {
    return attrValueFromShortKey('Postal Code');
  }

  function getPhone() {
    return attrValueFromShortKey('Phone');
  }

  function getSpecialInstructions() {
    return attrValueFromShortKey('Special Instructions');
  }

  function hasNoAddress() {
    return !!$locationForm.find('#chk_customPickup_noAddress:checked').length;
  }

  function hideLocationForm() {
    $locationForm.removeClass('shown');
    $showButton.prop('disabled', false);
    updateUiState();
  }

  function toggleNoAddressCheckbox() {
    var isDisabled = $noAddressCheckbox.is(':checked');
    $locationForm.find('input[type=text]:not(.locationForm__city),textarea').prop('disabled', isDisabled);
  }

  function editLocationForm() {
    $locationPanel.removeClass('shown');
    showLocationForm();
    $removeButton.hide();
  }

  function getCustomPickupCartItem() {
    var matchingItems = CartJS.cart.items.filter(function (item, idx) {
      if (customPickupHandles.includes(item.handle)) {
        item.lineNumber = idx + 1;
        return true;
      }

      return false;
    });
    return matchingItems.length ? matchingItems[0] : null;
  }

  function hasPickupCartItem() {
    return !!getCustomPickupCartItem();
  }

  function displayLocationPanel() {
    var street = getStreet();
    var apt = getApt();
    var city = getCity();
    var province = 'ON'; // Hardcoded for now, since BD doesn't operate or pickup outside Ontario

    var postal = getPostal();
    var phone = getPhone();
    var html = '<div class="title">Your Custom Pickup Location:</div>';
    var instructions = getSpecialInstructions();
    var noAddress = hasNoAddress();

    if (noAddress) {
      html += "We'll contact you closer to the event to confirm a pickup location";
    } else {
      var line1 = [];

      if (street) {
        line1.push(htmlEscape(street));
      }

      if (apt) {
        line1.push(htmlEscape(apt));
      }

      var line1Html = line1.length ? line1.join(', ') : null;
      var line2 = [];

      if (city) {
        line2.push(htmlEscape(city));
      }

      if (province) {
        line2.push(htmlEscape(province));
      }

      var line2Html = line2.length ? line2.join(', ') : null;

      if (postal) {
        var safePostal = htmlEscape(postal);
        line2Html = line2Html ? line2Html + " " + safePostal : safePostal;
      }

      var line3Html = phone ? htmlEscape(phone) : null;
      var addrLines = [line1Html, line2Html, line3Html].filter(function (v) {
        return v != null;
      });
      html += addrLines.join('<br>');
    }

    if (instructions) {
      html += "<br /><div class='title'>Special Instructions</div>" + htmlEscape(instructions).replace(/\n/g, '<br />');
    }

    $locationDescription.html(html);
    $locationPanel.addClass('shown');
  }

  function removeCustomPickup() {
    var clearAttrs = {
      'Has Custom Pickup': ''
    };
    clearAttrs[attrLocationIsSet] = '';
    attributeFields.forEach(function (attr) {
      clearAttrs[attr] = '';
    });
    CartJS.setAttributes(clearAttrs);
    var item = getCustomPickupCartItem();

    if (item) {
      CartJS.removeItem(item.lineNumber);
    }

    refreshAfterCartJsUpdate();
  }

  function confirmCustomPickup() {
    var noAddress = !!$locationForm.find('#chk_customPickup_noAddress:checked').length;
    var attrUpdates = {
      'Has Custom Pickup': 'YES'
    };
    attrUpdates[attrLocationIsSet] = noAddress ? 'NO' : 'YES'; // Loop through attribute names and move the values from the form to the cart attributes

    attributeFields.forEach(function (attrName) {
      var val = $locationForm.find('[name="attributes[' + attrName + ']"]').val();
      attrUpdates[attrName] = val;
    });
    CartJS.setAttributes(attrUpdates);
    var item = getCustomPickupCartItem();

    if (!item) {
      CartJS.addItem(customPickupVariant);
    }

    refreshAfterCartJsUpdate();
  }

  function refreshAfterCartJsUpdate() {
    $(document).one('cart.requestComplete', updateUiState);
  }
  /**
   * If a user changes the number of tickets that can affect the custom pickup price.  Ensure that
   * the custom pickup item matches what's expected.
   */


  function replaceInvalidCustomPickup() {
    var item = getCustomPickupCartItem();

    if (!item || item.handle == customPickupHandle) {
      return;
    }

    CartJS.removeItem(item.lineNumber);
    CartJS.addItem(customPickupVariant);
    refreshAfterCartJsUpdate();
  }

  function updateUiState() {
    if (hasPickupCartItem()) {
      $locationForm.removeClass('shown');
      displayLocationPanel();
      $showButton.hide();
      $removeButton.show();
    } else {
      $locationPanel.removeClass('shown');
      $showButton.show();
      $showButton.prop('disabled', false);
      $removeButton.hide();
    }
  }

  function init() {
    $customPickup = $('.cartOption--customPickup');

    if (!$customPickup.length) {
      return;
    }

    $showButton = $customPickup.find('.customPickup__showBtn');
    $removeButton = $customPickup.find('.customPickup__removeBtn');
    $locationPanel = $customPickup.find('.customPickup__locationPanel');
    $locationDescription = $customPickup.find('.customPickup__locationDescription');
    $locationForm = $customPickup.find('.customPickup__locationForm');
    $noAddressCheckbox = $customPickup.find('#chk_customPickup_noAddress');
    customPickupHandle = $customPickup.data('custom-pickup-handle');
    customPickupVariant = $customPickup.data('custom-pickup-variant');
    customPickupCity = $customPickup.data('custom-pickup-location');
    $showButton.on('click', showLocationForm);
    $customPickup.find('.customPickup__cancelBtn').on('click', hideLocationForm);
    $customPickup.find('.customPickup__removeBtn').on('click', removeCustomPickup);
    $customPickup.find('.customPickup__confirmBtn').on('click', confirmCustomPickup);
    $customPickup.find('.customPickup__editBtn').on('click', editLocationForm);
    $noAddressCheckbox.on('change', toggleNoAddressCheckbox);
    replaceInvalidCustomPickup();
    toggleNoAddressCheckbox();
    updateUiState();
  }

  $(document).on('cart.ready', init);
}(jQuery);
'use strict';
/**
 * BD.FullCollection: Populates a container with all elements of a collection, sorted by date.
 */

var BD = window.BD = window.BD || {};

BD.FullCollection = function ($) {
  var $collectionContainer;

  function init(containerId, collectionHandle) {
    $collectionContainer = $('#' + containerId);
    BD.CollectionLoader.load(collectionHandle, collectionLoadedHandler);
  }

  function collectionLoadedHandler(collection) {
    var $products = collection.$allProducts.clone().children();
    $products.sort(function (a, b) {
      var aYmd = a.querySelector('.tourbox').dataset.tourYmd || '';
      var bYmd = b.querySelector('.tourbox').dataset.tourYmd || '';
      return aYmd.localeCompare(bYmd);
    });
    $collectionContainer.empty().append($products);
  }

  return {
    init: init
  };
}(jQuery);
'use strict';
/**
 * BD.GoogleMap: Embeds google map into product pages.
 * 
 * ([JB, Mar 2019] Note this is currently disabled as we test OpenStreetMaps.  Feel free to
 * delete it if we end up not using it.) 
 */

var BD = window.BD = window.BD || {};

BD.GoogleMap = function ($) {
  var enabled = false;
  var gmApiKey = "";

  function onMapLoaded() {
    var mapCenter = [45.2487862, -76.3606792];
    var mapCenter = new google.maps.LatLng(mapCenter[0], mapCenter[1]);
    var bounds = new google.maps.LatLngBounds();
    var mapOptions = {
      mapTypeId: 'roadmap',
      zoom: 8,
      center: mapCenter
    }; // Display a map on the page

    var map = new google.maps.Map(document.getElementById("map_canvas"), mapOptions);
    map.setTilt(45);
    var markers = BD.mapMarkers;

    if (markers) {
      markers.forEach(function (marker, idx) {
        var position = new google.maps.LatLng(marker[1], markers[2]);
        bounds.extend(position);
        marker = new google.maps.Marker({
          position: position,
          map: map,
          title: marker[0],
          label: "LABEL" + idx,
          icon: 'https://cdn0.iconfinder.com/data/icons/alcohol-fill/512/white_beer-512.png'
        });
      }); // Automatically center the map fitting all markers on the screen

      map.fitBounds(bounds);
      console.log("NEWBOUNDS ", bounds);
    }

    ;
  }

  function init() {
    var script = document.createElement('script');
    script.src = "//maps.googleapis.com/maps/api/js?key=" + gmApiKey + "&callback=BD.Map.onMapLoaded";
    document.body.appendChild(script);
  }

  if (enabled) {
    $(init);
  }

  return {
    onMapLoaded: onMapLoaded
  };
}(jQuery);
'use strict';
/**
 * BD.GuestOptions: Code for managing the Guest Options cart step
 */

var BD = window.BD = window.BD || {};

BD.GuestOptions = function ($) {
  var $guestOptions;
  var $vipCheckboxes;
  var $vipCount;
  var $vipCountContainer;
  var guestCount;
  var maxVips;
  var hasCustomPickup;
  var submitCount = 0;

  function getGuestOptions() {
    var options;

    try {
      var guestFieldsStr = CartJS.getAttribute('guestFields');
      options = guestFieldsStr ? JSON.parse(guestFieldsStr) : {};
    } catch (e) {
      options = {};
    }

    options.guestNames = options.guestNames || [];
    options.guestVips = options.guestVips || [];
    options.guestMeals = options.guestMeals || [];
    options.guestLocations = options.guestLocations || [];
    return options;
  }

  function saveGuestOptions() {
    var newOptions = {
      guestNames: [],
      guestVips: [],
      guestLocations: [],
      guestMeals: []
    };
    $guestOptions.find('.guest-entry:not(#guestOption__rowTemplate)').each(function () {
      var $row = $(this);
      var idx = $row.data('guest-idx');
      newOptions.guestNames.push($row.find('.guestOption__name').val() || 'Guest ' + (idx + 1));
      newOptions.guestVips.push(!!$row.find('.vip-checkbox').is(':checked'));
      newOptions.guestLocations.push($row.find('.guestOption__pickup').val() || '');
      newOptions.guestMeals.push($row.find('.guestOption__meal').val() || '');
    });
    var optionString = JSON.stringify(newOptions || '{}');
    CartJS.setAttribute('guestFields', optionString);
  }

  function submit(e) {
    if (countSelectedVips() < maxVips && submitCount++ < 1) {
      e.preventDefault();
      $vipCountContainer.addClass('error');
      $('html, body').animate({
        scrollTop: $vipCountContainer.closest('.row').offset().top - 100
      }, 500);
    }
  }

  function buildTable() {
    var options = getGuestOptions();
    var $rowTemplate = $('#guestOption__rowTemplate');
    var $entries = $rowTemplate.closest('.entries');
    var defaultPickupValue = hasCustomPickup ? 'Custom' : $rowTemplate.find('.guestOption__pickup option').attr('value');
    var defaultMeal = $rowTemplate.find('.guestOption__meal option').attr('value');

    for (var i = 0; i < guestCount; i++) {
      var $row = $rowTemplate.clone().removeAttr('id');
      var chkId = 'chk-vip-' + i;
      $row.find('#chk-vip-x').attr('id', chkId);
      $row.find('.crown label').attr('for', chkId);
      var name = options.guestNames[i] || '';
      var meal = options.guestMeals[i] || defaultMeal;
      var isVip = options.guestVips[i] || false;
      var pickup = options.guestLocations[i] || defaultPickupValue;
      $row.data('guest-idx', i);
      $row.find('.guestOption__name').attr('placeholder', 'Guest ' + (i + 1)).val(name);
      $row.find('.guestOption__meal').val(meal);
      $row.find('.guestOption__pickup').val(pickup);
      $row.find('.vip-checkbox').prop('checked', isVip);
      $entries.append($row);
    }

    $vipCheckboxes = $guestOptions.find('.vip-checkbox');
    updateCheckboxStatuses();
  }

  function updateVipStatus(e) {
    var $this = $(this);
    var $vipChk = $this.closest('.crown').find('.vip-checkbox');

    if (countSelectedVips() > maxVips) {
      $vipChk.prop('checked', false);
    }

    updateCheckboxStatuses();
    saveGuestOptions();
  }

  function updateCheckboxStatuses() {
    var vipCount = countSelectedVips();
    $vipCount.text(vipCount);
    $vipCheckboxes.each(function () {
      var $this = $(this);
      $(this).closest('.crown').toggleClass('selected', $this.is(':checked'));
    });
    $vipCountContainer.removeClass('error');
  }

  function countSelectedVips() {
    var selected = CartJS.getAttribute('charity');
    return $vipCheckboxes.filter(':checked').length;
  }

  function selectAllMeals() {
    var meal = this.value;

    if (!meal) {
      return;
    }

    $guestOptions.find('.guestOption__meal').val(meal);
    $(this).prop('selectedIndex', 0);
    saveGuestOptions();
  }

  function selectAllPickups() {
    var pickup = this.value;

    if (!pickup) {
      return;
    }

    $guestOptions.find('.guestOption__pickup').val(pickup);
    $(this).prop('selectedIndex', 0);
    saveGuestOptions();
  }

  function init() {
    $guestOptions = $('#guestOptions');

    if (!$guestOptions.length) {
      return;
    }

    $vipCount = $guestOptions.find('.guestVip__count');
    $vipCountContainer = $vipCount.closest('.guest_vip');
    $guestOptions.on('change', '.guestOption__name', saveGuestOptions);
    $guestOptions.on('change', '.guestOption__meal', saveGuestOptions);
    $guestOptions.on('change', '.guestOption__pickup', saveGuestOptions);
    $guestOptions.on('change', '.vip-checkbox', updateVipStatus);
    $guestOptions.find('#guestOptions__selectAllMeals').on('change', selectAllMeals);
    var $allPickupsSelector = $guestOptions.find('#guestOptions__selectAllPickups');
    $allPickupsSelector.on('change', selectAllPickups);
    hasCustomPickup = !!$allPickupsSelector.find('option[value=Custom]').length;
    guestCount = $guestOptions.data('guest-count');
    maxVips = $guestOptions.data('max-vips');
    $('.btn--nextStep').on('click', submit);
    buildTable();
    saveGuestOptions();
  }

  $(document).on('cart.ready', init);
}(jQuery);
'use strict';
/**
 * BD.MoG: Handle Month of Giving UI
 */

var BD = window.BD = window.BD || {};

BD.MoG = function ($) {
  var $mog;
  var $mogOptionContainer;
  var submitCounter = 0;

  function refreshDisplay() {
    $mog.find('.mog__charity').removeClass('selected');
    var $selectedInput = $mog.find('input:checked');
    $selectedInput.closest('.mog__charity').addClass('selected');
    var hasSelected = !!$selectedInput.length;

    if (hasSelected) {
      CartJS.setAttribute('charity', $selectedInput.prop('value'));
    }

    $mogOptionContainer.toggleClass('error', !hasSelected);
  }

  function submit(e) {
    var selected = CartJS.getAttribute('charity');

    if (!selected && submitCounter++ < 3) {
      e.preventDefault();
      $('html, body').animate({
        scrollTop: $mogOptionContainer.offset().top
      }, 500);
      $mogOptionContainer.addClass('error');
    }
  }

  function init() {
    $mog = $('.cartOption--mog');

    if (!$mog.length) {
      return;
    }

    $mogOptionContainer = $('.cartOption--mog');
    $mog.find('input').on('change', refreshDisplay);
    $('.btn--nextStep').on('click', submit);
    var selectedCharity = CartJS.getAttribute('charity', null);
    $mog.find('input').filter(function (idx, el) {
      return el.value == selectedCharity;
    }).prop('checked', true);
    refreshDisplay(); // refreshDisplay will show the "field required" error, but we don't want it shown until submission

    $mogOptionContainer.removeClass('error');
  }

  $(document).on('cart.ready', init);
}(jQuery);
'use strict';
/**
 * BD.OpenStreetMap: Embeds OSM on product pages.
 */

var BD = window.BD = window.BD || {};

BD.OpenStreetMap = function ($) {
  var map; // Openmaps defaults to long/lat coordinates (https://openlayers.org/en/latest/doc/faq.html#why-is-the-order-of-a-coordinate-lon-lat-and-not-lat-lon-)
  // This function uses the more intuitive latitude/longitude transformation

  function pointFromLatLon(coords) {
    if (arguments.length == 2) {
      coords = arguments;
    }

    return ol.proj.fromLonLat([parseFloat(coords[1]), parseFloat(coords[0])]);
  }

  function init() {
    var mapElementId = 'map_canvas';
    var $map = $('#' + mapElementId).closest('.map-ui');

    if (!document.getElementById(mapElementId)) {
      return;
    }

    var mapCenter = [45.423283, -75.697609];
    var mapCenterPoint = pointFromLatLon(mapCenter);
    var markerPoints = !BD.mapMarkers ? [] : BD.mapMarkers.map(function (marker, idx) {
      if (!marker.lat || !marker["long"]) {
        return null;
      }

      var point = pointFromLatLon(marker.lat, marker["long"]);
      point.markerNum = idx + 1;
      point.name = marker.title;
      return point;
    }).filter(function (point) {
      return point != null;
    });
    var mapOptions = {
      layers: [//new ol.layer.Tile({ source: new ol.source.OSM() })
      //new ol.layer.Tile({ source: new ol.source.Stamen({ layer: "terrain" }) })
      new ol.layer.Tile({
        source: new ol.source.Stamen({
          layer: "toner-lite"
        })
      }) //new ol.layer.Tile({ source: new ol.source.Stamen({ layer: "toner" }) })
      ],
      target: mapElementId,
      view: new ol.View({
        center: mapCenterPoint,
        zoom: 16
      })
    };
    map = new ol.Map(mapOptions);

    if (markerPoints.length) {
      var ext = ol.extent.boundingExtent(markerPoints);
      map.getView().fit(ext, map.getSize());
    }

    markerPoints.forEach(function (point) {
      var markerEl = $('<div class="mapMarker"></div>').text(point.markerNum)[0];
      $map.append(markerEl);
      var overlay = new ol.Overlay({
        element: markerEl
      });
      map.addOverlay(overlay);
      overlay.setPosition(point);
    });
  }

  $(init);
  return {
    getMap: function getMap() {
      return map;
    }
  };
}(jQuery);
'use strict';
/**
 * BD.QuantityCounter: Manages quantity counters and handles +/- button clicks and cart updates
 */

var BD = window.BD = window.BD || {};

BD.QuantityCounter = function ($) {
  var lastActionTstamp = 0;
  var $counters;

  function setCartQuantity(variantId, quantity) {
    lastActionTstamp = Date.now();
    $counters.filter('[data-variant-id=' + variantId + ']').data('quantity', quantity);
    syncCartAndCounters();
  }

  function decrement($counter) {
    $counter = $counter instanceof $ ? $counter : $(this).closest('.quantityCounter');
    var variantId = $counter.data('variant-id');
    var desiredQuantity = Math.max(0, parseInt($counter.data('quantity') || 0) - 1);
    setCartQuantity(variantId, desiredQuantity);
  }

  function increment($counter) {
    $counter = $counter instanceof $ ? $counter : $(this).closest('.quantityCounter');
    var variantId = $counter.data('variant-id');
    var desiredQuantity = parseInt($counter.data('quantity') || 0) + 1;
    var maxQuantity = $counter.data('max-quantity');

    if (maxQuantity && maxQuantity < desiredQuantity) {
      desiredQuantity = maxQuantity;
    }

    setCartQuantity(variantId, desiredQuantity);
  }

  function setCounterQuantity($counter, quantity) {
    $counter.data('quantity', quantity);
    $counter.find('.quantityCounter__quantity').text(quantity);
    var incDisabled = $counter.data('max-quantity') && quantity >= $counter.data('max-quantity');
    var decDisabled = quantity == 0;
    $counter.find('.quantityCounter__incrementer').prop('disabled', incDisabled);
    $counter.find('.quantityCounter__decrementer').prop('disabled', decDisabled);
  }

  function setCountersFromCart() {
    var quantitiesByVariantId = {};
    CartJS.cart.items.forEach(function (item) {
      quantitiesByVariantId[item.variant_id] = item.quantity;
    });
    $counters.each(function (idx, el) {
      var $counter = $(el);
      var variantId = $counter.data('variant-id');
      var quantity = quantitiesByVariantId[variantId] || 0;
      setCounterQuantity($counter, quantity);
    });
  }

  function syncCartAndCounters(e) {
    /* If something goes wrong, we could end up sending hundreds of requests to 
     * Shopify as we attempt to correct an uncorrectable quantity.  So if there
     * were no user actions in the last 5 seconds and we're still trying to sync, 
     * just give up whatever we're doing and reset the counters to the current cart status. */
    if (Date.now() - lastActionTstamp > 5000) {
      setCountersFromCart();
      return;
    }

    var lineNumber = 1;
    var quantitiesByVariantId = {};
    var lineNumbersByVariantId = {};
    CartJS.cart.items.forEach(function (item) {
      quantitiesByVariantId[item.variant_id] = item.quantity;
      lineNumbersByVariantId[item.variant_id] = lineNumber++;
    });
    var updatesByVariantId = new Map();
    $counters.each(function () {
      var $counter = $(this);
      var variantId = $counter.data('variant-id');
      var cartQuantity = quantitiesByVariantId[variantId] || '0';
      var counterQuantity = $counter.data('quantity');

      if (counterQuantity === undefined) {
        counterQuantity = cartQuantity;
      } else if (counterQuantity != cartQuantity) {
        updatesByVariantId.set(variantId, counterQuantity);
      }

      setCounterQuantity($counter, counterQuantity);
    });
    /* Add and Remove operations cannot be batched and must be done one at a time.  This is because
     * quantity updates refer to line numbers, and add/remove operations can change the line numbers,
     * which can cause updates to happen on the wrong lines.
     * 
     * So we allow a single add/remove operation, then we wait for the response from Shopify, which
     * will trigger this function again.
     */

    var dontBatch = false;
    updatesByVariantId.forEach(function (quantity, variantId) {
      if (dontBatch) {
        return;
      }

      var isAddOp = !lineNumbersByVariantId[variantId];
      var isRemoveOp = !quantity;

      if (!isAddOp && !isRemoveOp) {
        return;
      }

      dontBatch = true;

      if (isAddOp) {
        CartJS.addItem(variantId, quantity);
      } else {
        CartJS.updateItem(lineNumbersByVariantId[variantId], 0);
      }
    });

    if (dontBatch) {
      return;
    }

    updatesByVariantId.forEach(function (quantity, variantId) {
      CartJS.updateItem(lineNumbersByVariantId[variantId], quantity);
    });
  }

  function init() {
    $counters = $('.quantityCounter');

    if (!$counters.length) {
      return;
    }

    $counters.find('.quantityCounter__decrementer').on('click', decrement);
    $counters.find('.quantityCounter__incrementer').on('click', increment);
    setCountersFromCart();
    $(document).on('cart.requestComplete', syncCartAndCounters);
  }

  $(document).on('cart.ready', init);
}(jQuery);
'use strict';
/**
 * BD.TourBrowser: Retrieve all tours, then display them according to user-selected filters.
 */

var BD = window.BD = window.BD || {};

BD.TourBrowser = function ($) {
  var DISPLAY_PAGE_SIZE = 12;
  var $tourBrowser;
  var $filterbar;
  var $results;
  var $allTours;
  var $filteredTours;
  var pagination = null;
  var weekdayBlackouts;
  var $catFilter;
  var $btnThisWeekend;
  var $btnNextWeekend;
  var $btnThisMonth;
  var $startDateFilter;
  var $endDateFilter;
  var $pagination;
  var $selectedDates;
  var $weekdayProduct = null;
  var lastRetrievedPage = 0;
  var pagesComplete = false;
  var loading = false; // These date ranges are formatted { start: '2019-01-01', end: '2019-01-31' }

  var thisWeekendDateRange;
  var nextWeekendDateRange;
  var thisMonthDateRange;
  var prettyDateOptions = {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  };
  var initialized = false;
  /**
   * Retrieve the next (or first) page of the tours, cache the results, and
   * start loading the next page.
   */

  function loadNextPage() {
    if (pagesComplete || loading) {
      return;
    }

    loading = true;
    lastRetrievedPage++;
    var url = '/collections/ott?view=raw&page=' + lastRetrievedPage;
    $.ajax(url, {
      success: function success(response) {
        // TODO: Consider using BD.CollectionLoader instead.
        if (response.trim()) {
          $allTours.append(response);
          var $hasMoreIndicator = $allTours.find('span.more-indicator');

          if ($hasMoreIndicator.length) {
            window.setTimeout(function () {
              return loadNextPage();
            }, 1);
          } else {
            pagesComplete = true;
          }

          $hasMoreIndicator.remove();
        } // No content in response
        else {
            pagesComplete = true;
          }

        if (pagesComplete) {
          loading = false;
          $allTours.trigger('loading-complete');
        }
      },
      complete: function complete() {
        loading = false;
        refreshResults();
      }
    });
  }

  function loadWeekdayProduct() {
    if (!window.BD.weekdayTourData || !window.BD.weekdayTourData.productUrl) {
      return;
    }

    var url = "".concat(window.BD.weekdayTourData.productUrl, "?view=raw");
    $.ajax(url, {
      success: function success(response) {
        var html = response.trim();

        if (!html) {
          return;
        }

        $weekdayProduct = $(html);
        refreshResults();
      }
    });
  }

  function onLoadingComplete(callback) {
    var fnCallback = function fnCallback() {
      return callback($allTours.find('.card-ui'));
    };

    if (pagesComplete) {
      fnCallback();
    }

    $allTours.on('loading-complete', fnCallback);
  }

  function ensureAllToursExists() {
    if (!$allTours || !$allTours.length) {
      $allTours = $('#tours__all');

      if (!$allTours || !$allTours.length) {
        $allTours = $('<div style="display: none"></div>').appendTo('body');
      }
    }
  }

  function refreshResults() {
    var selectedCategory = $catFilter.val();
    var startYmd = ($startDateFilter.val() || '').replace(/-/g, '');
    var endYmd = ($endDateFilter.val() || '').replace(/-/g, '');
    var $tours = $allTours.children();
    $tours.each(function (idx, tour) {
      var dateStr = tour.querySelector('.card-ui').dataset.tourYmd;
      var dateTimeStr = "".concat(dateStr.substr(0, 4), "-").concat(dateStr.substr(4, 2), "-").concat(dateStr.substr(6, 2), "T00:00:00.000Z");
      var date = new Date(dateTimeStr);
      tour.tourDate = date;
    });
    var dateRe = /[0-9]{8}/;
    var hasDate = !!(startYmd || endYmd);
    $selectedDates.toggleClass('shown', hasDate);

    if (hasDate) {
      var startNumeric = startYmd ? parseInt(startYmd) : null;
      var endNumeric = endYmd ? parseInt(endYmd) : null;
      $tours = $tours.filter(function (idx, el) {
        var ymd = '' + $(el).find('.card-ui').data('tour-ymd');
        if (!ymd) return false;

        if (!ymd.match(dateRe)) {
          return false;
        }

        ymd = parseInt(ymd);
        return (!startNumeric || startNumeric <= ymd) && (!endNumeric || endNumeric >= ymd);
      });
    }

    var startStr = getPrettyStart();
    var endStr = getPrettyEnd();
    var desc = '';
    var descLabel = '';

    if (startStr && endStr) {
      descLabel = 'From';
      desc = startStr + ' - ' + endStr;
    } else if (startStr) {
      descLabel = 'From';
      desc = startStr;
    } else if (endStr) {
      descLabel = 'Before';
      desc = endStr;
    }

    if (desc) {
      $selectedDates.find('.dateFilter__selectedDateDesc').text(desc);
      $selectedDates.find('.dateFilter__selectedDateDescLabel').text(descLabel);
    }

    if (selectedCategory) {
      $tours = $tours.filter(function (idx, el) {
        var cats = $(el).find('.card-ui').data('tour-cats');
        if (!cats) return false;
        cats = cats.split(',');
        return cats.includes(selectedCategory);
      });
    }

    var sortFnByDate = function sortFnByDate(a, b) {
      var ymdA = '' + $(a).find('.card-ui').data('tour-ymd');
      var ymdB = '' + $(b).find('.card-ui').data('tour-ymd');

      if (ymdA == ymdB) {
        return 0;
      }

      if (!ymdA) {
        return 1;
      }

      if (!ymdB) {
        return -1;
      }

      return ymdA.localeCompare(ymdB);
    };

    $tours = $tours.sort(sortFnByDate);
    /**
     * If weekday tours are configured, insert one between every weekend.  "Weekend"
     * is the first non-zero (Sunday) day per week. 
     */

    if ($weekdayProduct && $tours.length) {
      var firstTourDate = $tours.first()[0].tourDate;
      var lastTourDate = $tours.last()[0].tourDate;
      var weekdayTourNodes = createWeekdayTourNodes(firstTourDate, lastTourDate);
      weekdayTourNodes.forEach(function (tour) {
        return $tours = $tours.add(tour);
      });
      $tours = $tours.sort(sortFnByDate);
    }

    $filteredTours = $tours;
    pagination = newPagination($filteredTours.length);
    displayPage(0);
  }

  function createWeekdayTourNodes(startDate, endDate) {
    var curDate = new Date(startDate);
    var endTstamp = endDate.getTime();
    var tourNodes = []; // Start on a Sunday

    curDate.setUTCDate(curDate.getUTCDate() - curDate.getUTCDay());

    while (curDate.getTime() < endTstamp) {
      var _node = createWeekdayTourNode(curDate);

      if (_node) {
        tourNodes.push(_node);
      }

      curDate.setUTCDate(curDate.getUTCDate() + 7);
    } // Add a final tour after the last date


    var node = createWeekdayTourNode(curDate);

    if (node) {
      tourNodes.push(node);
    }

    return tourNodes;
  }

  function createWeekdayTourNode(date) {
    var availableDateHtml = buildWeekdayTourAvailableDateHtml(date); // If all the dates are blacked out, don't add a weekday tour

    if (!availableDateHtml) {
      return null;
    } // Set tour dates to Wednesday so they appear appropriately in the calendar


    var tourDate = new Date(date);
    tourDate.setUTCDate(tourDate.getUTCDate() + 3);
    var tourNode = $weekdayProduct[0].cloneNode(true);
    tourNode.tourDate = tourDate;
    var tourYmd = "".concat(tourDate.getUTCFullYear()).concat((tourDate.getUTCMonth() + 1).toString().padStart(2, '0')).concat(tourDate.getUTCDate().toString().padStart(2, '0'));
    tourNode.querySelector('.card-ui').setAttribute('data-tour-ymd', tourYmd);
    tourNode.querySelector('.date__text').innerHTML = availableDateHtml;
    tourNode.querySelector('.time__text').innerHTML = window.BD.weekdayTourData.timeLabel;
    return tourNode;
  }

  function populateNoResultsMessage() {
    var msg = "No results found";
    var endYmd = $endDateFilter.val();
    var startStr = getPrettyStart();
    var endStr = getPrettyEnd();

    if (startStr && endStr) {
      msg += " between " + startStr + ' and ' + endStr;
    } else if (startStr) {
      msg += " after " + startStr;
    } else if (endStr) {
      msg += " before " + endStr;
    }

    $tourBrowser.find('#tourBrowser__noResults').text(msg);
  }
  /**
   * Updates the results and pagination panels based on the "$filteredTours"
   * and "pagination" variables. 
   */


  function displayPage(pageNum) {
    var noResults = pagination.itemCount == 0;
    var noPages = pagination.numPages <= 1;
    $tourBrowser.toggleClass('no-results', noResults);
    $tourBrowser.toggleClass('no-pages', noPages);
    $results.empty();

    if (noResults) {
      populateNoResultsMessage();
      return;
    }

    pageNum = Math.max(pageNum, 0);
    pageNum = Math.min(pageNum, pagination.numPages - 1);
    pagination.currentPage = pageNum;
    var itemOffset = pageNum * DISPLAY_PAGE_SIZE;
    var $pageItems = $filteredTours.slice(itemOffset, itemOffset + DISPLAY_PAGE_SIZE);
    $results.append($pageItems.clone());
    var isFirst = pageNum == 0;
    var isLast = pageNum == pagination.numPages - 1;
    $pagination.find('.btn--prev').toggleClass('disabled', isFirst).attr('disabled', isFirst).off('click').on('click', function () {
      return displayPage(pageNum - 1);
    });
    $pagination.find('.btn--next').toggleClass('disabled', isLast).attr('disabled', isLast).off('click').on('click', function () {
      return displayPage(pageNum + 1);
    });
    $pagination.find('.btn--pageButton').remove();
    var $pageButtonTemplate = $pagination.find('.btn--pageButtonTemplate');
    var $buttonInsertCursor = $pageButtonTemplate;

    for (var i = 0; i < pagination.numPages; i++) {
      var isSelected = pageNum == i;
      var pageOnClick = i;
      var $pageButton = $pageButtonTemplate.clone().removeClass('btn--pageButtonTemplate').addClass('btn--pageButton').toggleClass('selected', isSelected).attr('bd-pageNum', i).on('click', function (e) {
        return displayPage(e.currentTarget.getAttribute('bd-pageNum'));
      }).show();
      $pageButton.find('.pageNumber').text(i + 1);
      $pageButton.insertAfter($buttonInsertCursor);
      $buttonInsertCursor = $pageButton;
    }
  }

  function buildWeekdayTourAvailableDateHtml(nextTourDate) {
    var dates = [];
    var curDate = new Date(nextTourDate.getTime());
    curDate.setUTCDate(curDate.getUTCDate() - curDate.getUTCDay()); // Build one week of tour days, starting on Sunday

    for (var i = 0; i < 7; i++) {
      var newDate = new Date(curDate.getTime());
      newDate.setUTCDate(newDate.getUTCDate() + i);
      dates.push(newDate);
    }

    var tagStart = '<span class="weekdayTour__availableDate">';
    var tagEnd = '</span>';
    var dateStr = weekdayBlackouts.buildDateStr(dates, "".concat(tagEnd).concat(tagStart));
    return dateStr ? tagStart + dateStr + tagEnd : '';
  }

  function newPagination(itemCount) {
    return {
      itemCount: itemCount,
      numPages: Math.ceil(itemCount / DISPLAY_PAGE_SIZE),
      currentPage: 0
    };
  }

  function getDateRangeStructure(startDate, endDate) {
    var startDateISO = startDate.toISOString().substr(0, 10);
    var endDateISO = endDate.toISOString().substr(0, 10);
    return {
      start: startDateISO,
      end: endDateISO
    };
  }
  /**
   * Finds the weekend date range for a specific date.  Weekends span 3 days (Fri-Sun).
   * 
   * For Mon-Thu, the weekend starts on the next Friday.  
   * For Fri-Sat, the weekend starts on the current/prior Friday.
   * 
   * @param date Date
   */


  function weekendDateRangeFromDate(date) {
    var weekendStart = new Date(date);
    var weekendEnd = new Date(date); // day-of-month for the weekend to start.  May end up <0 or >31 but
    // it gets automatically normalized later.

    var lastSundayDate = date.getUTCDate() - date.getUTCDay();
    var nextFridayDate = lastSundayDate + 5;
    var nextSundayDate = lastSundayDate + 7;
    weekendStart.setUTCDate(nextFridayDate);
    weekendEnd.setUTCDate(nextSundayDate);
    return getDateRangeStructure(weekendStart, weekendEnd);
  }

  function getPrettyStart() {
    var startYmd = $startDateFilter.val();
    return startYmd ? new Date(Date.parse(startYmd)).toLocaleDateString('en-US', prettyDateOptions) : null;
  }

  function getPrettyEnd() {
    var endYmd = $endDateFilter.val();
    return endYmd ? new Date(Date.parse(endYmd)).toLocaleDateString('en-US', prettyDateOptions) : null;
  }

  function getThisWeekendDateRange() {
    return weekendDateRangeFromDate(new Date());
  }

  function getNextWeekendDateRange() {
    var nextWeek = new Date();
    nextWeek.setUTCDate(nextWeek.getUTCDate() + 7);
    return weekendDateRangeFromDate(nextWeek);
  }

  function getThisMonthDateRange() {
    var endOfMonth = new Date(); // "This month" means 31 days from today

    endOfMonth.setUTCDate(endOfMonth.getUTCDate() + 31);
    return getDateRangeStructure(new Date(), endOfMonth);
  }

  function updateStartDate(val) {
    updateDateRangeFromStrings(val, $endDateFilter.val());
  }

  function updateEndDate(val) {
    updateDateRangeFromStrings($startDateFilter.val(), val);
  }

  function updateDateRangeFromStructure(structure) {
    updateDateRangeFromStrings(structure.start, structure.end);
  }

  function resetDates() {
    updateDateRangeFromStrings('', '');
  }
  /**
   * Updates the filter inputs and refreshes the results.
   * 
   * @param start string E.g. 2019-08-21
   * @param end string E.g. 2019-10-30
   */


  function updateDateRangeFromStrings(start, end) {
    $startDateFilter.val(start);
    $endDateFilter.val(end);
    refreshResults();
  }

  function init() {
    if (initialized) {
      return;
    }

    initialized = true;
    $tourBrowser = $('#tourBrowser');
    $filterbar = $('#tourBrowser__filterbar');
    $pagination = $('#tourBrowser__pagination');
    $results = $('#tourBrowser__results');
    ensureAllToursExists();
    $selectedDates = $tourBrowser.find('.dateFilter__selectedDates');
    $catFilter = $('#catFilter');
    thisWeekendDateRange = getThisWeekendDateRange();
    $btnThisWeekend = $filterbar.find('button.dateFilter--thisWeekend');
    $btnThisWeekend.on('click', function () {
      return updateDateRangeFromStructure(thisWeekendDateRange);
    });
    nextWeekendDateRange = getNextWeekendDateRange();
    $btnNextWeekend = $filterbar.find('button.dateFilter--nextWeekend');
    $btnNextWeekend.on('click', function () {
      return updateDateRangeFromStructure(nextWeekendDateRange);
    });
    thisMonthDateRange = getThisMonthDateRange();
    $btnThisMonth = $filterbar.find('button.dateFilter--thisMonth');
    $btnThisMonth.on('click', function () {
      return updateDateRangeFromStructure(thisMonthDateRange);
    });
    $startDateFilter = $filterbar.find('.dateFilter--startDate');
    $endDateFilter = $filterbar.find('.dateFilter--endDate');
    $catFilter.on('changex', refreshResults);
    $startDateFilter.on('change', refreshResults);
    $endDateFilter.on('change', refreshResults);
    $selectedDates.find('#btnDateReset').on('click', resetDates); // Start loading the tours into the cache.

    loadNextPage();

    if (window.BD.weekdayTourData) {
      loadWeekdayProduct();
      var weekdayBlackoutStrings = window.BD.weekdayTourData.blackoutDates;
      var leadTimeDays = window.BD.weekdayTourData.leadTimeDays || 0;
      var firstAvailableDate = window.moment().add(leadTimeDays, "days");
      var leadTimeBlackout = "2020-01-01 - ".concat(firstAvailableDate.utc().format('YYYY-MM-DD'));
      weekdayBlackoutStrings += "\n" + leadTimeBlackout;
      weekdayBlackouts = new window.BD.BlackoutDates(weekdayBlackoutStrings);
      weekdayBlackouts.dateRangeJoin = 'thru';
    }
  }

  return {
    init: init,
    $allTours: $allTours,
    onLoadingComplete: onLoadingComplete,
    updateStartDate: updateStartDate,
    updateEndDate: updateEndDate
  };
}(jQuery);
'use strict';
/**
 * Upcoming tour list requires us to retrieve all products.  We can't build the list on the backend 
 * because there can be more than 50 items in the product list.  
 */

var BD = window.BD = window.BD || {};

BD.Upcoming = function ($) {
  var $upcomingContainer;
  var sixteenHoursInMs = 57600 * 1000;

  function getAllUpcoming($tours) {
    var dateRe = /[0-9]{8}/;
    return $tours.filter(function (idx, el) {
      var ymd = '' + el.dataset['tourYmd'];

      if (!ymd || !ymd.match(dateRe)) {
        return false;
      }

      var intVal = parseInt(ymd);

      if (!intVal || isNaN(intVal)) {
        return false;
      }

      var date = ymd.substring(0, 4) + '-' + ymd.substring(4, 6) + '-' + ymd.substring(6, 8); // Continue to show "upcoming" until 4pm on the same day.

      return Date.parse(date) + sixteenHoursInMs > Date.now();
    });
  }

  function showUpcoming($tours) {
    var tours = getAllUpcoming($tours).get();
    tours = tours.sort(function (a, b) {
      var ymdA = parseInt(a.dataset['tourYmd']);
      var ymdB = parseInt(b.dataset['tourYmd']);
      return ymdA - ymdB;
    });
    var upcomingTours = tours.slice(0, 3);
    $upcomingContainer.empty();
    upcomingTours.forEach(function (e) {
      var $div = $('<div class="col col-33"></div>').appendTo($upcomingContainer);
      $(e).clone().appendTo($div);
    });
  }

  function init() {
    // We use the tour browser data to load upcoming tours
    BD.TourBrowser.init();
    $upcomingContainer = $('#section--upcoming-tours .grid-ui');
    BD.TourBrowser.onLoadingComplete(showUpcoming);
  }

  return {
    init: init
  };
}(jQuery);
'use strict';

if (!window.NA) {
  window.NA = {};
}
/**
 * Usage:
 * <div na-modal-target='the-modal'>Click Here to open the modal!</div>
 * <div class='na-modal-container' id='the-modal' na-modal-target>
 *  <div class="na-modal-content'>
 *    Here's a modal.
 *    <button na-modal-close>Click here to close.</button>
 *  </div>
 * <div>
 * 
 * Additional Options:
 * * na-disable-ezclose: This attribute on a modal target will disable Esc and clicking-outside to close the modal.
 * 
 * TODO: The container is mostly infrastructure.  We should create it with jquery rather 
 * than requiring it in the markup 
 */


window.NA.Modal = function ($) {
  // Close the target modal
  function close(target) {
    var $target = $(target);
    $(document.body).removeClass('na-modal-is-open');
    $(document).off('.closeModal');
    $(window).off('.modalNoScroll');
    $target.removeClass('na-modal--open');
    if ($target.attr('id') == "externalModal") $target.remove();
    $target.trigger('na-modal-closed');
  }
  /**
   * Close the modal using an "easy" method like Esc or clicking outside the modal, rather
   * than an explicit close button.  Can be disabled with attribute na-disable-ezclose on 
   * the modal element. 
   */


  function ezClose(target) {
    var $target = $(target);

    if (!$target.is('[na-disable-ezclose]')) {
      close($target);
    }
  }

  function init() {
    // Clicks on na-modal-triggers open the targeted modal
    $(document.body).on('click', '[na-modal-trigger]', function (e) {
      e.preventDefault();
      triggerModal(this.getAttribute('na-modal-trigger'));
    });
    /* Clicks outside of the modal close it.  This works because the [na-modal-target]
     * attribute is only present on the container/overlay, so click events on elements
     * within the modal won't pass the [na-modal-target] attribute test, but clicks on
     * the overlay element will */

    $(document.body).on('click', '[na-modal-target]', function (e) {
      if (e.target.attributes['na-modal-target']) ezClose(e.target);
    }); // Clicks on close buttons close their parent modal

    $(document.body).on('click', '[na-modal-close]', function (e) {
      e.preventDefault();
      closeParent(e.target);
    });
  }

  function closeParent(target) {
    var $popup = $(target).closest('[na-modal-target]');
    close($popup);
  }
  /**
   * Keypress event handler.  Detects Esc-key presses, then closes any open modals
   */


  function closeOnEsc(ev, $target) {
    if (ev.keyCode == 27) {
      ev.preventDefault();
      ezClose($target);
    }
  }

  function triggerModal(target) {
    // Close existing modals
    if (document.querySelector('.na-modal-container.na-modal--open')) close(document.querySelector('.na-modal-container.na-modal--open'));

    if (target instanceof $) {
      $target = target;
    } else {
      $target = $('#' + target);
    }

    var $target = target instanceof $ ? target : $('#' + target);

    if (!$target.length) {
      return;
    }

    $(document.body).addClass('na-modal-is-open');
    $target.addClass('na-modal--open');
    $(document).on('keydown.closeModal', function (ev) {
      closeOnEsc(ev, $target);
    }); // Disable scrolling.  We're not using overflow:hidden style because it can shift the window
    // contents as the vertical scrollbar disappears.

    var currentScrolltop = $(window).scrollTop();
    $(window).on('scroll.modalNoScroll', function (ev) {
      $(window).scrollTop(currentScrolltop);
      return false;
    });
  }

  $(init);
  return {
    triggerModal: triggerModal,
    closeParent: closeParent
  };
}(jQuery);